// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e8F6gICQDHMh3wp0WrD5{background-color:rgba(0,0,0,0);border:none}`, "",{"version":3,"sources":["webpack://./src/components/Users/RoleSelect/role-select.module.scss"],"names":[],"mappings":"AAAA,sBACI,8BAAA,CACA,WAAA","sourcesContent":[".roleSelect {\n    background-color: transparent;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roleSelect": `e8F6gICQDHMh3wp0WrD5`
};
export default ___CSS_LOADER_EXPORT___;
